<template>
    <b-modal ref="modal" size="lg" centered :title="$t('NOTIFICATIONFORM')" @close="close()" no-close-on-backdrop
        no-close-on-esc hide-footer>
        <div class="d-block mt-2">
            <div role="group" class="b-form-group form-group" v-if="formData != null">
                <div class="form-row mb-lg">
                    <div class="col-sm-10">
                        <b-form-fieldset v-bind:label="$t('TITLE')">
                            <inputvalidation :formerror="formError" name="title">
                                <b-form-input type="text" v-model="formData.title"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                    <div class="col-sm-2">
                        <inputvalidation :formerror="formError" name="isActive">
                            <label class="custom-label">{{ $t('ISACTIVE') }}</label>
                            <b-form-checkbox plain v-model="formData.isActive" name="checkboisActive" :value="1"
                                :unchecked-value="0">
                            </b-form-checkbox>
                        </inputvalidation>
                    </div>
                </div>
                <div class="form-row mb-lg">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('MESSAGE')">
                            <wysiwyg v-model="formData.message" />
                        </b-form-fieldset>
                    </div>
                </div>
            </div>

            <div class="text-right">
                <b-btn class="mr-2 button-cancel" @click="close()">{{ $t('CLOSE') }}</b-btn>
                <b-btn class="button-save" @click="submitData(formData)">{{ $t('SAVE') }}</b-btn>
            </div>
        </div>
    </b-modal>
</template>

<script>
import {
    mapGetters,
}
    from 'vuex';
import Api from '@/api/notifications/Notifications.js';

export default
    {
        name: 'NotificationForm',
        props: ['value'],
        data() {
            const me = this;

            return {
                formError: {},
                formData: null,
            };
        },
        methods:
        {
            async submitData(item) {
                const me = this;
                try {
                    if (typeof item.notificationId !== 'undefined') {
                        item.id = item.notificationId;
                        delete (item.notificationId);
                    }

                    const data = await Api.submitData(item);
                    me.$notify.notice(data);

                    if (data.error) {
                        me.formError = data;
                    }
                    else {
                        me.close();
                    }
                }
                catch (e) {
                    console.log(e);
                    me.$notify.notice(e);
                }
            },
            close() {
                const me = this;
                me.formError = {};
                me.formData = null;
                me.$emit('close');
            },
        },
        watch:
        {
            async formData(val) {
                const me = this;
                if (val != null) {
                    me.$refs.modal.show();
                }
                else {
                    me.$refs.modal.hide();
                }
            },
            value(val) {
                const me = this;
                if (val != null) {
                    me.formData = { ...val };
                }
                else {
                    me.formData = null;
                }
            },
        },
        computed:
        {
            ...mapGetters([
                'globals',
            ]),
        },
    };
</script>
